import React from "react";
import { Controller } from "react-hook-form";

import Input from "../../../../../../../../components/inputs/Input";
import Dropdown from "../../../../../../../../components/inputs/Dropdown";
import { useGetRoles } from "../../../../../../../../services/microservice/admin/agents/use-agents-admin";
import { useAuthAgentGetMe } from "../../../../../../../../services/microservice/admin/auth/use-auth-agents";
import { useGetSponsorsList } from "../../../../../../../../services/microservice/admin/sponsors/use-sponsors-admin";

const FormFields = ({ control, errors }) => {
  const { data: Role } = useGetRoles();
  const { data: Agent } = useAuthAgentGetMe();
  const { data: Sponsors } = useGetSponsorsList();
  return (
    <>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="Nombre"
            error={errors.name?.message}
            required
          />
        )}
      />
      <Controller
        name="phoneNumber"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="Número de teléfono"
            error={errors.phoneNumber?.message}
            required
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="Correo electrónico"
            error={errors.email?.message}
            required
          />
        )}
      />
      <Controller
        name="password"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="Contraseña"
            error={errors.password?.message}
            required
            type="password"
          />
        )}
      />
      <Controller
        name="role"
        control={control}
        render={({ field }) => (
          <Dropdown
            options={Role?.data.roles || []}
            label1="name"
            prop1=""
            placeholder="Selecciona el rol"
            error={errors.role?.message}
            required
            {...field}
          />
        )}
      />
      {Agent?.data?.user?.roles[0]?.idSystem === "SUPERADMIN" && (
        <Controller
          name="sponsor"
          control={control}
          render={({ field }) => (
            <Dropdown
              options={Sponsors?.data?.sponsors || []}
              label1="name"
              prop1=""
              placeholder="Selecciona el sponsor"
              error={errors.role?.message}
              required
              {...field}
            />
          )}
        />
      )}
    </>
  );
};
export default FormFields;
